/**
 * Storm Initializer
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 *
 * WARNING: This JS may not be served by the same service as the one which serves
 * HTML/CSS which this JS depends on. E.g. this JS may be served by a BabyStorm
 * while the HTML/CSS may be served by Storm. Take care when updating this JS or any
 * related HTML/CSS.
 * See https://wiki.yext.to/index.php/Postmortem:IN-1085_Capacity_Limit_Exceeded_Modal_in_Customer_Portal#Root_causes
 * for context.
 *
 * Home for all the global init functions for Storm
 *
 */

goog.module('yext.storm');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.localization');
/** @suppress {extraRequire} */
goog.require('yext.plugins.characterCounter');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');
/** @suppress {extraRequire} */
goog.require('yext.storm.AccountDropdown');
const PixelTracking = goog.require('yext.storm.PixelTracking');
/** @suppress {extraRequire} */
goog.require('yext.storm.StormInitializer');
/** @suppress {extraRequire} */
goog.require('yext.storm.base');
const navigation = goog.require('yext.storm.navigation');
const tablefade = goog.require('yext.ui.tablefade');
require('jquery-ui/ui/widgets/tooltip');


/**
 * Common initialization for all pages in storm
 * @param {!Object} options
 * @suppress {deprecated}
 */
function init(options) {
  $('select:not(.add-location)').selectbox();

  // Initialize our new selectbox, and avoid triggering the old
  // and handle positioning our dropdown
  $('.gumi').gumi(yext.gumiConfig);

  // Initialize custom character counters
  $('.js-character-counter').characterCounter();

  // Initialize contextual help and bootstrap tooltip
  $('.info-icon, .custom-info-icon, .js-bind-contextual-help').contextualHelp({fade: true});

  // intialize tooltips
  $('.js-tooltip').tooltip();

  $(window).resize(function() {
    $('.ui-dialog-content').dialog('option', 'position', ['center', 'center']);
  });

  navigation.init();

  tablefade.init();

  PixelTracking.init();
}
goog.exportSymbol('yext.storm.init', init);

exports = {
  init,
};
